function initializePreloaderClock(clockSelector) {
  let currentTime = 0;

  function updateClock(clock) {
    const speed = 2.5;
    currentTime += speed;

    const secondAngle = currentTime;

    const secondHand = clock.querySelector('.second-hand');
    secondHand.style.transform = `rotate(${secondAngle}deg)`;
  }

  function animateClocks() {
    const clocks = document.querySelectorAll(clockSelector);
    clocks.forEach(clock => {
      updateClock(clock);
    });
    
    window.requestAnimationFrame(animateClocks);
  }

  // Start the animation loop as soon as the script is executed
  window.requestAnimationFrame(animateClocks);
}

// Call the function to initialize the clock with the new animation loop
initializePreloaderClock('.clock');